/* @flow */

import React from 'react';

export default class Footer extends React.PureComponent {
  render(): ?React.Element<any> {
    return (
      <div>
        &copy; California Polytechnic State University
      </div>
    );
  }
}
